// import Vue from 'vue';
// import app from "./app.vue";
// import routes from './routes';
// import store from './store';
// import Antd from 'ant-design-vue';
// import VueRouter from 'vue-router';
// import moment from 'moment';

import "es6-promise/auto";
import "babel-polyfill";

import Vue from "vue";
import VueRouter from "vue-router";
import Antd from "ant-design-vue";

import app from "./app.vue";
import routes from "./routes";
import store from "./store";
import moment from "moment";

import "ant-design-vue/dist/antd.less";
import "~/styles/flex.scss";
import "~/styles/style.scss";

Vue.config.productionTip = false;

moment.locale("ko");

Vue.use(Antd);
Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to: any, from: any, savedPosition: any) {
    return { x: 0, y: 0 };
  },
});

new Vue({
  router,
  store,
  render: (h) => h(app),
}).$mount("#app");
